module.exports = __webpack_public_path__ + "static/fonts/opensans-regular-webfont.ebeefa4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/opensans-regular-webfont.woff
// module id = sIih
// module chunks = 2